import { INTERNAL, INTERNAL_MAX_AGE, INTERNAL_PATH } from '../config/internal'

export const setInternal = () => {
	document.cookie = `${INTERNAL}; max-age=${INTERNAL_MAX_AGE}; path=${INTERNAL_PATH}`
}
